export default __webpack_public_path__ + "static/turing-2d6888302d5e8b1e25f709e8cdeeec3c.png";